import "./App.css";
import React, { useEffect, useState, useSyncExternalStore } from "react";
import { Route, Routes, Switch, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import ActAs from "./pages/ActAs";
import RASearch from "./pages/RASearch";
import RADetails from "./pages/RADetails";
import SalePriceLists from "./pages/SalePriceLists";
import ExcelReports from "./pages/ExcelReports";
import TKExcelReports from "./pages/TKExcelReports";
import CSVFromLWH from "./pages//RaCreation/CSVFromLWH";
import BasketMaintenance from "./pages/BasketMaintenance";
import TKDashboard from "./pages/TKDashboard";
import SapMasterData from "./pages/SapMasterData";
import MaintenanceSetup from "./pages/MaintenanceSetup";
import { LoadingProvider } from "./components/LoadingContext";
import { Provider } from "react-redux";
import store from "./redux/store";
import ProtectedRoute from "./components/Authentication/ProtectedRoute";
import ProtectedAdminRoute from "./components/Authentication/ProtectedAdminRoute";
import Login from "./pages/Login";
import { loadUserFromStorage, createUserManager } from "./services/userService";
import AuthProvider from "./utils/authProvider";
import { toast, Toaster, ToastBar } from "react-hot-toast";
import SigninOidc from "./components/Authentication/SigninOidc";
import SignoutOidc from "./components/Authentication/SignoutOidc";
import Wrapper from "./components/Wrapper";
import axios from "./api/axiosClient";
import { debounce, ReduxKEY, saveState } from './redux/browser-storage';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs/AdapterDayjs';
import UploadExcel from './pages/UploadExcel';
import QCDetail from "./pages/QC/QCDetail";
import QCItem from "./pages/QC/QCItem";
import QCDefect from "./pages/QC/QCDefect";
import QCDefectAttachments from "./pages/QC/QCDefectAttachments";
import CheckIn from "./pages/CheckIn";
import ManualRTV from "./pages/CreditNote/ManualRTV";
import RAPreparing from "./pages/CreditNote/RAPreparing";
import BoxInQC from "./pages/QC/BoxInQC";
import FromInvoice from "./pages/RaCreation/FromInvoice";
import FASTExtractions from "./pages/FASTExtractions";
import CreditNoteDestinationTriang from "./pages/CreditNoteDestinationTriang";
import BasketSearch from "./pages/BasketCreation/BasketSearch";
import UploadUDMList from "./pages/UploadUDMList";
import Maintenance from "./pages/Maintenance";
import { getMaintenanceInfo } from "./services/maintenanceService";
import {
  subscribeMaintenance,
  getMaintenanceInfoSnapshot,
  setMaintenanceInfo,
} from "./utils/maintenanceStore";

function App() {
  const [scriptConstantsEvaluated, setScriptsConstantsEvaluated] =
    useState(false);
  const [userManager, setUserManager] = useState(null);
  const [maintenanceChecked, setMaintenanceChecked] = useState(false);
  const maintenanceInfo = useSyncExternalStore(
    subscribeMaintenance,
    getMaintenanceInfoSnapshot
  );

  useEffect(() => {
    function loadApp() {
      axios
        .get("login/loginpropsWeb")
        .then((response) => {
          window.authenticationConfig = response.data;
          setScriptsConstantsEvaluated(true);
          let um = createUserManager();
          setUserManager(um);
          loadUserFromStorage(store, um);
        })
        .catch((error) => {debugger;});
    }

    getMaintenanceInfo(
      (info) => {
        setMaintenanceChecked(true);
        if (info && info.isActive) {
          setMaintenanceInfo(info);
        } else {
          loadApp();
        }
      },
      () => {
        setMaintenanceChecked(true);
        loadApp();
      }
    );
  }, []);

  // Maintenance can start while the user is already inside the SPA: re-check on every page change.
  const location = useLocation();
  useEffect(() => {
    if (!maintenanceChecked) return;
    getMaintenanceInfo(
      (info) => {
        if (info && info.isActive) {
          setMaintenanceInfo(info);
        }
      },
      () => {}
    );
  }, [location.pathname]);

  store.subscribe(
    debounce(() => {
      saveState(store.getState(), ReduxKEY);
    }, 1000)
  );

  if (!maintenanceChecked) {
    return <div></div>;
  }

  if (maintenanceInfo && maintenanceInfo.isActive) {
    return <Maintenance maintenanceInfo={maintenanceInfo} />;
  }

  return scriptConstantsEvaluated && userManager ? (
    <Provider store={store}>
      <script src="https://cdn.jsdelivr.net/npm/tweetnacl-util@0.15.0/nacl-util.min.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/tweetnacl@1.0.1/nacl.min.js"></script>
      <Wrapper>
        <Toaster
          toastOptions={{
            style: {
              maxWidth: "600px",
            },
          }}
        />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AuthProvider userManager={userManager} store={store}>
            <LoadingProvider>
              <Routes>
                <Route
                  path={`${process.env.PUBLIC_URL}/basketmaintenance`}
                  element={<BasketMaintenance />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/login`}
                  element={<Login />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/login/:fromAutomaticLogout`}
                  element={<Login />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/signout`}
                  element={<SignoutOidc />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/signin`}
                  element={<SigninOidc />}
                />
                <Route element={<Layout />}>
                  <Route
                    path={`${process.env.PUBLIC_URL}/`}
                    element={
                      <ProtectedRoute>
                        <Home />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/ActAs`}
                    element={
                      <ProtectedRoute>
                        <ActAs />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/RASearch`}
                    element={
                      <ProtectedRoute>
                        <RASearch />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/RADetail/:idReturnFileHead`}
                    element={
                      <ProtectedRoute>
                        <RADetails />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/UploadFullPrice`}
                    element={
                      <ProtectedRoute>
                        <SalePriceLists
                          discriminant={"FullPrice"}
                          withQty={false}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/UploadMarkDown`}
                    element={
                      <ProtectedRoute>
                        <SalePriceLists
                          discriminant={"MarkDown"}
                          withQty={false}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/UploadFullPriceQty`}
                    element={
                      <ProtectedRoute>
                        <SalePriceLists
                          discriminant={"FullPrice"}
                          withQty={true}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/UploadMarkDownQty`}
                    element={
                      <ProtectedRoute>
                        <SalePriceLists
                          discriminant={"MarkDown"}
                          withQty={true}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/UploadPackaging`}
                    element={
                      <ProtectedRoute>
                        <SalePriceLists
                          discriminant={"Packaging"}
                          withQty={false}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/UploadPackagingQty`}
                    element={
                      <ProtectedRoute>
                        <SalePriceLists
                          discriminant={"Packaging"}
                          withQty={true}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/CSVFromLWH`}
                    element={
                      <ProtectedRoute>
                        <CSVFromLWH isTriangulation={false} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/CSVFromLWHTriangulation`}
                    element={
                      <ProtectedRoute>
                        <CSVFromLWH isTriangulation={true} />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/ExcelReports`}
                    element={
                      <ProtectedRoute>
                        <ExcelReports />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/TkDashboard`}
                    element={
                      <ProtectedAdminRoute>
                        <TKDashboard />
                      </ProtectedAdminRoute>
                    }
                 />
                <Route
                    path={`${process.env.PUBLIC_URL}/TrackingDataUpdate`}
                    element={
                    <ProtectedRoute>
                        <UploadExcel type="TrackingData" />
                    </ProtectedRoute>
                } />
                <Route
                    path={`${process.env.PUBLIC_URL}/UrgentFlagMassiveUpdate`}
                    element={
                    <ProtectedRoute>
                        <UploadExcel type="UrgentFlag" />
                    </ProtectedRoute>
                } />
                <Route
                    path={`${process.env.PUBLIC_URL}/ToBeRepairedUpload`}
                    element={
                    <ProtectedRoute>
                        <UploadExcel type="ToBeRepaired" />
                    </ProtectedRoute>
                } />
                <Route
                    path={`${process.env.PUBLIC_URL}/MassiveClosureUpload`}
                    element={
                    <ProtectedRoute>
                        <UploadExcel type="MassiveClosure" />
                    </ProtectedRoute>
                } />
                  <Route
                    path={`${process.env.PUBLIC_URL}/QCDetail/:idReturnFileHead`}
                    element={
                      <ProtectedRoute>
                        <QCDetail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/QCItem/:idReturnFileHead/:idArticle`}
                    element={
                      <ProtectedRoute>
                        <QCItem />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/QCItem/:idReturnFileHead/:idArticle/:boxBarcode`}
                    element={
                      <ProtectedRoute>
                        <QCItem />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/QCDefect/:idReturnFileHead/:idArticle/:idQualityCheck`}
                    element={
                      <ProtectedRoute>
                        <QCDefect />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/QCDefect/:idReturnFileHead/:idArticle/:idQualityCheck/:idDefectForQC`}
                    element={
                      <ProtectedRoute>
                        <QCDefect />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/QCDefectAttachments/:idReturnFileHead/:idArticle/:idDefectForQC/:hash`}
                    element={
                      <ProtectedRoute>
                        <QCDefectAttachments />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/BoxInQC/:idReturnFileHead`}
                    element={
                      <ProtectedRoute>
                        <BoxInQC />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/CheckIn/:idReturnFileHead/`}
                    element={
                      <ProtectedRoute>
                        <CheckIn />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/ManualRTV/`}
                    element={
                      <ProtectedRoute>
                        <ManualRTV />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/RAPreparing/:idReturnFileHead/`}
                    element={
                      <ProtectedRoute>
                        <RAPreparing />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/SAPMasterData`}
                    element={
                      <ProtectedAdminRoute>
                        <SapMasterData />
                      </ProtectedAdminRoute>
                    }
                 />
                 <Route
                    path={`${process.env.PUBLIC_URL}/MaintenanceSetup`}
                    element={
                      <ProtectedAdminRoute>
                        <MaintenanceSetup />
                      </ProtectedAdminRoute>
                    }
                 />
                 <Route
                    path={`${process.env.PUBLIC_URL}/FromInvoice/`}
                    element={
                      <ProtectedRoute>
                        <FromInvoice />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/FASTExtractions/`}
                    element={
                      <ProtectedRoute>
                        <FASTExtractions />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/CreditNoteDestinationTriang/`}
                    element={
                      <ProtectedRoute>
                        <CreditNoteDestinationTriang />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/BasketSearch/`}
                    element={
                      <ProtectedRoute>
                        <BasketSearch />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/UploadUDMList/`}
                    element={
                      <ProtectedRoute>
                        <UploadUDMList />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/TKInbound`}
                    element={
                      <ProtectedRoute>
                        <TKExcelReports exportType="TKI" />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/TKOutbound`}
                    element={
                      <ProtectedRoute>
                        <TKExcelReports exportType="TKO" />
                      </ProtectedRoute>
                    }
                  />
                </Route>                
              </Routes>
            </LoadingProvider>
          </AuthProvider>
        </LocalizationProvider>
      </Wrapper>
    </Provider>
  ) : (
    <div></div>
  );
}

export default App;
